import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@material-ui/core';
import VMask from 'vanilla-masker';

export function Input({ control, name, controllerProps = {}, type, ...rest }) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <TextField
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          {...field}
          {...rest}
          onBlur={(event) => {
            field?.onBlur?.(event);
            rest?.onBlur?.(event);
          }}
          value={
            type === 'number'
              ? VMask.toNumber(field?.value ?? '')
              : field?.value ?? ''
          }
        />
      )}
      {...controllerProps}
    />
  );
}

export default Input;
